export default __webpack_public_path__ + "static/media/card-blog3.2d89e0b5.jpg";